var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 8.7L7.30307 13.6969C7.23547 13.7645 7.18622 13.8482 7.15996 13.9402L6.27816 17.0265C6.15692 17.4508 6.54922 17.8431 6.97354 17.7218L10.0598 16.84C10.1518 16.8138 10.2355 16.7645 10.3031 16.6969L15.3 11.7M12.3 8.7L13.5 7.5C14.3284 6.67157 15.6716 6.67157 16.5 7.5V7.5C17.3284 8.32843 17.3284 9.67157 16.5 10.5L15.3 11.7M12.3 8.7L15.3 11.7",
    stroke: "#878787",
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b707186246dd0b4258426b5281759cb3.svg";
export { ForwardRef as ReactComponent };